/**
 * Shared direction + status contract for the blotter surfaces
 * (watchlist / open positions / history). Proposal 13 — blotter parity.
 */

import { VybeOrderState } from "@/vybe-trader-client/trade-history/types";

/** Which way a position/order runs. */
export type Direction = "buy" | "sell";

/** The three design-system status roles (green / yellow / red). */
export type Status = "ok" | "warn" | "err";

/**
 * Pure mapping from a {@link VybeOrderState} onto one of the three status
 * roles. This is the only new logic introduced by proposal 13.
 *
 * - Filled / Placed / RequestAdding  → ok   (settled / accepted / in-flight add)
 * - Partial / RequestModifying / RequestCancelling / Started → warn (in-progress)
 * - Cancelled / Rejected / Expired   → err  (terminal failure)
 */
export function deriveStatus(state: VybeOrderState): Status {
  switch (state) {
    case VybeOrderState.Filled:
    case VybeOrderState.Placed:
    case VybeOrderState.RequestAdding:
      return "ok";
    case VybeOrderState.Started:
    case VybeOrderState.Partial:
    case VybeOrderState.RequestModifying:
    case VybeOrderState.RequestCancelling:
      return "warn";
    case VybeOrderState.Cancelled:
    case VybeOrderState.Rejected:
    case VybeOrderState.Expired:
      return "err";
    default:
      return "warn";
  }
}
